<template>
  <div class="home" v-if="!isCasinoLoading">
    <carousel-full v-if="!isLoadingBanners" :banners="casino_banners"></carousel-full>
    <div class="container-games">
      <games-filter-component
        :isDesktop="isDesktop"
        :sectionsFilters="filters"
        :games_providers="allSkinProviders"
        :sections="kajotPrime_sections"
        :isCasinoLoading="isCasinoLoading"
      ></games-filter-component>
      <base-loading v-if="isLoadingCardGames && isLoadingBanners"></base-loading>
      <div class="container predefined">
        <ul>
          <span
            class="reel-games-btn"
            @click="viewGamewithReels(null)"
            id="all_reel"
            :class="{ actived: selectedReels === null }"
            >{{ translations?.casino?.all_reel_games ?? "All" }}</span
          >
          <span
            class="reel-games-btn"
            @click="viewGamewithReels(3)"
            id="3_reel"
            :class="{ actived: selectedReels === 3 }"
            >{{ translations?.casino?.is_3_reel_game ?? "3-reel games" }}</span
          >
          <span
            class="reel-games-btn"
            @click="viewGamewithReels(4)"
            id="4_reel"
            :class="{ actived: selectedReels === 4 }"
            >{{ translations?.casino?.is_4_reel_game ?? "4-reel games" }}</span
          >
          <span
            class="reel-games-btn"
            @click="viewGamewithReels(5)"
            id="5_reel"
            :class="{ actived: selectedReels === 5 }"
            >{{ translations?.casino?.is_5_reel_game ?? "5-reel games" }}</span
          >
        </ul>
      </div>
      <card-game-container v-if="!isCasinoLoading && !isLoadingCardGames">
      </card-game-container>
    </div>
  </div>
</template>

<script>
import CarouselFull from "@/components/elements/CarouselFull.vue";
import CardGameContainer from "@/components/global/ui/CardGameContainer.vue";
import GamesFilterComponent from "@/components/elements/GamesFilterComponent.vue";
import { mapGetters } from "vuex";

export default {
  name: "CasinoPage",
  components: {
    CarouselFull,
    CardGameContainer,
    GamesFilterComponent,
  },
  data() {
    return {
      filters: [],
    };
  },
  computed: {
    ...mapGetters("casino", [
      "selectedGames",
      "isCasinoLoading",
      "kajotPrime_sections",
      "allSkinProviders",
      "isLoadingCardGames",
      "reels_games_selected",
    ]),
    ...mapGetters("device", ["isDesktop", "isTablet", "isMobile", "isDesktopSize"]),
    // ...mapGetters("device", ["isDesktop"]),
    ...mapGetters("skinBanners", ["casino_banners", "isLoadingBanners"]),
    selectedReels() {
      return this.reels_games_selected;
    },
  },
  async created() {
    this.$store.dispatch("skinBanners/callBanners", "home");
    let language = localStorage.getItem("language");
    this.$router.push({ params: { lang: language } });

    await this.$store.dispatch("casino/changingPage", { currentPage: 1 }).then(() => {
      this.$store.dispatch("casino/callSkinProviders", this.filters);
    });
  },
  mounted() {
    // const lang = localStorage.getItem("language") || "en";
    // const titles = {
    //   en: "Kajot Online Casino | Home",
    //   sk: "Kajot Online Casino | Home",
    //   cs: "Kajot Online Casino | Hlavní Stránka",
    //   de: "Kajot Online Casino | Startseite",
    //   hu: "Kajot Online Casino | Itthon",
    // };
    // document.title = titles[lang] || "Kajot Online Casino";
    document.title =
      this.translations?.body?.kajotPrimeTitle ?? "Kajot Online Casino | Kajot Prime";
  },
  methods: {
    viewGamewithReels(reels) {
      this.$store.dispatch("casino/viewGamebySelectedReels", reels);
      this.$store.dispatch("casino/changingPage", { currentPage: 1 });
    },
  },
  beforeUnmount() {
    //reset filter of the reels
    this.viewGamewithReels(null);
  },
};
</script>

<style scoped>
.predefined {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 15px;
  overflow-x: auto;
}

.predefined ul {
  list-style-type: none;
  padding-left: 0px;
  margin-bottom: 0px;
  padding: 5px 0px;
  text-align: center;
  white-space: nowrap;
}
.predefined .reel-games-btn {
  min-width: 35px;
  padding: 0px 10px;
  cursor: pointer;
  transition: var(--short-trans);
  color: var(--darker-grey);
  font-weight: 600;
  display: inline;
  position: relative;
}

.predefined .reel-games-btn::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 1px;
  background-color: rgba(127, 2, 21, 0.7);
}

.predefined .reel-games-btn:last-child::after {
  display: none;
}

.predefined .reel-games-btn:hover {
  text-decoration: underline;
}

.actived {
  text-decoration: underline;
  color: var(--dark-orange) !important;
  font-weight: 600;
}

::-webkit-scrollbar {
  height: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--dirty-white);
  border-radius: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--dark-orange);
  border-radius: 2px;
  transition: var(--short-trans);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--light-orange);
  transition: var(--short-trans);
}

/* Media query for mobile devices */
@media screen and (max-width: 768px) {
  .predefined {
    flex-wrap: nowrap;
  }

  .predefined .reel-games-btn {
    white-space: nowrap;
  }
}
</style>
